
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Status, Scalers } from "../constant";
import LazyImage from "./LazyImage.vue";
import {
  HomesPlan,
  LotCountNeighborhood,
  PlanNeighborhoodList,
  SidebarHomePlan,
} from "./../types";
import LocationIcon from "@/assets/icons/Location.vue";
import { addImageScaler, compareSortingValue } from "@/core";
import { isMobile, isTablet } from "mobile-device-detect";
@Component({
  components: {
    LazyImage,
    LocationIcon,
  },
})
export default class SidebarPlanListItem extends Vue {
  private availableStatus = Status;
  private hasMobile = !!(isMobile && !isTablet);
  planClicks = {};
  private previousSelectedPlan = "";
  @Prop() private selectedJobNum!: string;
  @Prop() private qmiAndHomeplans!: any[];
  @Prop() private selectedHomePlanIds!: string[];
  @Prop() private selectedLotId!: string;
  @Prop() private selectedHomePlanId!: string;
  @Prop() private selectedLotStatus!: string;
  @Prop() availableLots!: number;
  @Prop() neighborhoodId!: string;
  @Prop() private isKioskMode!: boolean;
  @Prop() private listHomeType!: string[];
  @Prop() private selectedNeighborhoodIds!: string[];
  @Prop() private lotsCount!: LotCountNeighborhood[];
  @Prop() initialHomePlanCount!: number;
  @Emit("setHomePlanId") setHomePlanId(planId: string, jobNum: string) {}
  @Emit("CleanHomeId") CleanHomeId() {}
  @Emit("toggleshowFilters") toggleshowFilters() {}
  @Watch("selectedLotId") resetPlanClicks() {
    if (this.selectedLotId) this.planClicks = {};
  }
  @Watch("qmiAndHomeplans") onChangeListPlanNameId() {
    this.changePlanClicks();
  }
  get availableLotsPresent() {
    if (this.selectedNeighborhoodIds.length) {
      const count = this.lotsCount.find(
        (neighborhoodLot) =>
          neighborhoodLot.neighborhoodId === this.selectedNeighborhoodIds[0]
      )?.available;
      return !!count && count > 0;
    } else {
      let count = 0;
      for (const neighborhoodLot of this.lotsCount) {
        if (neighborhoodLot?.available) {
          count += neighborhoodLot?.available;
        }
      }
      return !!count && count > 0;
    }
  }
  changePlanClicks() {
    Object.keys(this.planClicks).forEach((planId) => {
      this.qmiAndHomeplans.forEach((plan) => {
        let data = "";
        data = !plan.job_number ? plan.plan_id : plan.job_number;
        if (data !== planId) this.planClicks = {};
      });
    });
  }
  getPlanImageUrl(homePlan) {
    return !Object.keys(homePlan).includes("thumbnail_img")
      ? homePlan.image[0]
      : homePlan.thumbnail_img;
  }
  QmiplanClickAction(homePlan) {
    if (this.hasMobile) {
      this.toggleshowFilters();
    }
    homePlan.price >= 0
      ? this.planQmiClickAction(
          homePlan.plan_code,
          homePlan.job_number,
          homePlan.details_url
        )
      : this.planClickAction(homePlan.plan_id, homePlan.plan_url);
  }
  planClickAction(planId: string, planURL: Location) {
    if (this.previousSelectedPlan !== planId) {
      delete this.planClicks[planId];
    }
    this.previousSelectedPlan = planId;
    if (!this.planClicks[planId]) {
      this.planClicks[planId] = 0;
    }
    this.planClicks[planId]++;
    if (this.planClicks[planId] % 2) this.setHomePlanId(planId, "");
    else this.CleanHomeId();
  }

  formatDate(moveInDate: string) {
    let date = new Date(moveInDate);
    let formattedDate = date.toDateString().split(" ");
    return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
  }
  planQmiClickAction(planId: string, jobNum: string, planURL: Location) {
    if (this.previousSelectedPlan !== jobNum) {
      delete this.planClicks[jobNum];
    }
    this.previousSelectedPlan = jobNum;
    if (!this.planClicks[jobNum]) {
      this.planClicks[jobNum] = 0;
    }
    this.planClicks[jobNum]++;
    if (this.planClicks[jobNum] % 2) this.setHomePlanId("", jobNum);
    else this.CleanHomeId();
  }
  formatPrice(value) {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    });
    return formatter.format(value);
  }
  addScaler(url) {
    return addImageScaler(url);
  }
  redirectToPlanPage(planId: string, planURL: Location) {
    if (this.isKioskMode) {
      const kioskPlanLink = `${process.env.VUE_APP_KIOSK_URL}planView?plan_code=${planId}&neighborhood_code=${this.neighborhoodId}`;
      window.open(`${kioskPlanLink}`, `HomePlans_WindowName`);
    } else {
      window.open(`${planURL}`, `HomePlans_WindowName`);
    }
  }
  sortNeighborhoods(neighborhoods: PlanNeighborhoodList[]) {
    const list = [] as PlanNeighborhoodList[];
    Object.assign(list, neighborhoods);
    return list.sort((first: PlanNeighborhoodList, second: PlanNeighborhoodList) => {
      return compareSortingValue(first.neighborhood_name, second.neighborhood_name);
    });
  }
  generateKey(homePlan, index) {
    return `${homePlan.plan_code || 'no-plan-code'}-${homePlan.plan_id || 'no-plan-id'}-${homePlan.future_id || 'no-future-id'}-${index}`;
  }
}
